<template>
    <div class="work-content" :id="id">
        <p>{{ content }}</p>
        <test-audio v-if="isShowAudioPlayer" :audio="audio" :isShowAudioPlayer="isShowAudioPlayer"></test-audio>
        <WorkImgs v-if="type === 'housework' && images !== undefined" :id="imgId" :imgArr="images"></WorkImgs>
        <div v-else>
            <el-image class="work-content-img" :fit="'cover'" :preview-src-list="images"
                :style="{ width: imgSize + 'px', height: imgHeight === 'auto' ? imgHeight : imgHeight + 'px' }"
                v-for="(item, index) in images" :key="index" :src="item" alt="" />
        </div>
    </div>
</template>

<script>
import TestAudio from '../components/TestAudio.vue'
import WorkImgs from '../components/WorkImgs.vue'
export default {
    components: { TestAudio, WorkImgs },
    data () {
        return {

        }
    },
    props: {
        id: {
            type: String,
            default: 'work'
        },
        imgId: {
            type: String
        },
        content: {
            type: String,
        },
        audio: {
            type: String
        },
        isShowAudioPlayer: {
            type: Boolean,
            default: false
        },
        images: [Array, String],
        imgSize: {
            type: Number,
            default: 160
        },
        imgHeight: {
            type: [Number, String],
            default: 'auto'
        },
        type: {
            type: String,
            default: 'normal'
        }
    },
    watch: {
        images (val, oldval) {
            this.images = val
        }
    }

}
</script>

<style lang="scss" scoped>
.work-content {
    // height: 580px;
    // overflow: hidden;
    // overflow-y: scroll;
    color: #7C8184;

    .work-content-img {
        margin: 20px 10px 0;
        // width: 160px;
        // height: 160px;
    }

    p {
        white-space: pre-wrap;
        word-break: break-all;
        color: #333;
        line-height: 26px;
        text-align: justify;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/WorkContent.vue